module.exports = __webpack_public_path__ + "img/el-ahorcado.baa61c58.jpg";